const updateTex = (text: number, counter: HTMLSpanElement): void => {
  counter.textContent = text.toString()
}

const animation = (endValue: number, counter: HTMLSpanElement): void => {
  let startTime = null

  const step = (): void => {
    const currentTime = Date.now()
    if (!startTime) startTime = currentTime

    const progress = Math.min((currentTime - startTime) / 1000, 1)
    const currentNum = Math.floor(progress * endValue)
    updateTex(currentNum, counter)
    progress < 1 ? window.requestAnimationFrame(step) : window.cancelAnimationFrame(window.requestAnimationFrame(step))
  }
  window.requestAnimationFrame(step)
}

const startAnimation = (): void => {
  const $counterHolders = document.querySelectorAll<HTMLSpanElement>('[data-landing-numbers]')
  $counterHolders.forEach((counter): void => {
    const endValue = counter.innerHTML
    animation(parseInt(endValue, 10), counter)
  })
}

export const initCountersObserver = (): void => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startAnimation()
        observer.unobserve(entry.target)
      }
    })
  })
  const $elem = document.querySelector<HTMLSpanElement>('[data-landing-numbers]')
  $elem && observer.observe($elem)
}
